import { tabs as AccountTabs } from '../../screens/landing-site/account';
import { acrossHosts, getExploreURL } from './_';
import { adminRoutes } from './admin';
import { districtRoutes } from './district';
import { accountRoutes, exploreRoutes, landingRoutes, orgRoutes, propertyRoutes, onSubdomain } from './general';
const hasKey = (value, key) => key in value;
// What a page is called when a "Back to" link points at it; null for pages a back link should not name.
export const backLabel = (location) => {
    const at = location.ismatch;
    if (at(exploreRoutes.explore.path))
        return 'Explore';
    if (at(landingRoutes.root.path))
        return 'Home';
    if (at(districtRoutes.properties.path))
        return districtRoutes.properties.nav.label;
    if (at(adminRoutes.myProperties.path))
        return adminRoutes.myProperties.nav.label;
    if (at(adminRoutes.properties.path))
        return adminRoutes.properties.nav.label;
    if (at(accountRoutes.accountDefault.path))
        return AccountTabs['my-properties'].label;
    const account = at(accountRoutes.account.path);
    if (account)
        return hasKey(AccountTabs, account.tab) ? AccountTabs[account.tab].label : null;
    if (at(adminRoutes.stories.path))
        return adminRoutes.stories.nav.label;
    if (at(adminRoutes.toursWizard.path))
        return 'Tour';
    if (at(orgRoutes.story.path))
        return 'Story';
    if (at(propertyRoutes.property.path))
        return 'Property';
    return null;
};
// Where a page about a place sends a visitor with nothing behind it: on a community's site, its list of
// homes for a signed-in visitor (the list is for signed-in visitors only); everyone else, the map.
export const browseProperties = (signedIn) => onSubdomain && signedIn
    ? { 'label': 'All properties', 'href': districtRoutes.properties.getURL(), 'icon': districtRoutes.properties.nav.icon }
    : { 'label': 'Explore the map', 'href': getExploreURL(), 'icon': 'bi-map' };
// A page's button: a step back to where the visitor came from when that page has a name, else the onward link.
export const resolveBackLink = (parse, current, origin, onward, own) => {
    const fallback = Object.assign({ 'kind': 'onward' }, onward);
    if (origin === null)
        return fallback;
    const from = parse(origin);
    if (from.raw === current.raw)
        return fallback;
    const label = own !== null && from.raw === parse(own.href).raw ? own.label : backLabel(from);
    return label === null ? fallback : { 'kind': 'back', label, 'href': acrossHosts(origin) };
};
